import React from 'react';
import { Users, Car, Wrench, Headphones } from 'lucide-react';
import { features, stats } from '../data/mock';

const iconMap = { Users, Car, Wrench, HeadphonesIcon: Headphones };

const Features = () => {
  return (
    <section id="about" className="relative py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block px-3 py-1 rounded-full bg-sky-100 text-sky-700 text-xs font-semibold tracking-wide uppercase mb-4">
            Why MaLife
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-[#0b2f5c] tracking-tight mb-4">
            Empowering everyday life
          </h2>
          <p className="text-slate-600 text-lg leading-relaxed">
            From safe rides to essential services — MaLife brings convenience to your fingertips, wherever life takes you in Botswana.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-20">
          {features.map((f, idx) => {
            const Icon = iconMap[f.icon] || Users;
            return (
              <div
                key={f.title}
                className="group relative bg-white rounded-2xl p-7 border border-slate-200/70 hover:border-sky-300 hover:-translate-y-1 transition-all duration-300 hover:shadow-xl hover:shadow-sky-100"
              >
                <div className="absolute top-4 right-4 text-6xl font-bold text-slate-100 group-hover:text-sky-50 transition-colors">
                  0{idx + 1}
                </div>
                <div className="relative w-14 h-14 rounded-2xl bg-gradient-to-br from-sky-100 to-sky-50 flex items-center justify-center mb-5 group-hover:from-sky-400 group-hover:to-sky-600 transition-all duration-300">
                  <Icon
                    className="w-7 h-7 text-sky-500 group-hover:text-white transition-colors"
                    strokeWidth={2}
                  />
                </div>
                <h3 className="text-lg font-bold text-[#0b2f5c] mb-2 relative">{f.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed relative">{f.desc}</p>
              </div>
            );
          })}
        </div>

        {/* Stats bar */}
        <div className="bg-gradient-to-r from-[#0b2f5c] to-[#0f3a70] rounded-3xl p-8 md:p-12 relative overflow-hidden">
          <div className="absolute -top-24 -right-24 w-64 h-64 bg-sky-400/20 rounded-full blur-3xl" />
          <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-sky-500/20 rounded-full blur-3xl" />
          <div className="relative grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((s) => (
              <div key={s.label} className="text-center md:text-left">
                <div className="text-3xl md:text-4xl font-bold bg-gradient-to-b from-white to-sky-200 bg-clip-text text-transparent mb-1">
                  {s.value}
                </div>
                <div className="text-sm text-white/70">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
